import { IStorage } from "./IStorage";

export default class LocalStorage implements IStorage {
  public clear(): void {
    localStorage.clear();
  }

  public getItem(key: string): string {
    return localStorage.getItem(key) || "";
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
}
